export default "__VITE_ASSET__f6a83200__"